// Contact Information - Single Source of Truth
// This file contains all contact details used across the Bethanchok Homestay website

export const CONTACT_INFO = {
  // Primary contact details
  phone: '+977-9841691517',
  whatsapp: '9841691517', 
  email: 'bethanchokstay@gmail.com',
  bookingEmail: 'bethanchokstay@gmail.com',
  
  // Address information
  address: {
    village: 'Bethanchok',
    municipality: 'Bethanchok Rural Municipality',
    district: 'Kavrepalanchok',
    province: 'Bagmati Province', 
    country: 'Nepal',
    fullAddress: 'Bethanchok, Kavrepalanchok, Nepal'
  },
  
  // Geographic coordinates for maps
  coordinates: {
    lat: 27.509065,
    lng: 85.496547
  },
  
  // Business operating hours
  businessHours: {
    checkIn: '14:00',
    checkOut: '11:00',
    responseTime: '24 hours',
    officeHours: '9:00 AM - 6:00 PM (Nepal Time)'
  }
};

// Social media and online presence
export const SOCIAL_LINKS = {
  facebook: 'https://facebook.com/kuberd',
  instagram: 'https://instagram.com', 
  tripadvisor: 'https://tripadvisor.com',
  whatsapp: `https://wa.me/${CONTACT_INFO.whatsapp.replace(/[^0-9]/g, '')}`,
  email: `mailto:${CONTACT_INFO.email}`
};

// Website and business information
export const BUSINESS_INFO = {
  name: 'Bethanchok Homestay',
  tagline: 'Authentic Nepali Experience',
  description: 'Experience authentic Nepali hospitality in the serene village of Bethanchok.',
  shortDescription: 'Traditional homestay in the heart of Nepal',
  keywords: ['Nepal homestay', 'Bethanchok', 'traditional accommodation', 'cultural experience', 'mountain views'],
  website: 'https://bethancokstay.com',
  established: '2024'
};

// Emergency and additional contacts
export const EMERGENCY_CONTACTS = {
  owner: {
    name: 'Kuber Dhakal',
    phone: '+977-9841691517',
    role: 'Owner & Manager'
  },
  localGuide: {
    name: 'Local Guide Service',
    phone: '+977-9841691517',
    role: 'Trekking & Cultural Tours'
  }
};

// Platform-specific contact methods
export const CONTACT_METHODS = {
  booking: {
    primary: CONTACT_INFO.bookingEmail,
    secondary: CONTACT_INFO.phone,
    whatsapp: CONTACT_INFO.whatsapp
  },
  inquiries: {
    primary: CONTACT_INFO.email,
    secondary: CONTACT_INFO.phone
  },
  emergency: {
    primary: EMERGENCY_CONTACTS.owner.phone,
    local: '+977-11-123456' // Local emergency number
  }
};

// Export all contact-related constants
export default {
  CONTACT_INFO,
  SOCIAL_LINKS, 
  BUSINESS_INFO,
  EMERGENCY_CONTACTS,
  CONTACT_METHODS
};
